import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * The albums library moved to /audiolab/releases. Kept as a redirect so
 * existing bookmarks and links out in the wild still land somewhere real.
 */
export const Route = createFileRoute("/audiolab/albums/")({
  beforeLoad: () => {
    throw redirect({ to: "/audiolab/releases", replace: true });
  },
});
